import ApisApi from 'api/apis'

// actions
const actions = {
  // get api request
  apiInfo({ rootGetters }) {
    return ApisApi.apiInfo(Object.assign({}, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }))
  },

  // update api request
  updateApis({ rootGetters }, params) {
    return ApisApi.updateApiInfo(Object.assign({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }))
  },

  // send application
  sendApplication(state, params) {
    return ApisApi.sendApplication(params)
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/apis.js